export const DEFAULT_SLOT_NAME = null;
//# sourceMappingURL=BlockDecorator.js.map